import GradePage from "@/pages/GradePage";
export default function GradeGeometry() {
  return <GradePage grade="10" />;
}
